<template>
  <div fluid fill-height>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <v-container style="min-width: 100% !important">
      <Cards/>
    </v-container>
  </div>
</template>
<script>
import Cards from '../../components/Definiciones/Tarjetas/Cards.vue';
import LandingToolbar from "@/components/LandingToolbar/LandingToolbar.vue";
    
    export default {
    components: { LandingToolbar, Cards },
    };
</script>
    